import { StorageKeys } from '@dealstack/frontend/shared/helper/storageUtils.ts';
import { HoldingsSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/HoldingsSection.tsx';
import { useVehicleHoldings } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestmentVehicleDetails/components/VehicleHoldingsCard/useVehicleHoldings.ts';

interface Props {
	dealId: string;
	personId: string;
	vehicleName?: string;
}

export const VehicleHoldingsCard = ({ dealId, personId, vehicleName }: Props) => {
	const { rows, isLoading, isError } = useVehicleHoldings({ personId });

	return (
		<HoldingsSection
			dealId={dealId}
			rows={rows}
			isLoading={isLoading}
			isError={isError}
			viewStorageKey={StorageKeys.MIP_INVESTMENT_VEHICLE_DETAILS_HOLDINGS_VIEW}
			heldColumn="for"
			holderFilterName={vehicleName || rows[0]?.heldViaName || undefined}
		/>
	);
};
